import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { logoutResponse } from 'src/app/models/logoutResponse';
import {
  ForgotPassword,
  LoginBody,
  ResetPasswordPayload,
  signUpBody,
  ProfileDetails,
  verifyEmailOrPhone
} from 'src/app/models/authmodel';
import { changePasswordPayload } from 'src/app/models/changePasswordPayload';
import { AddressPayload } from 'src/app/models/addressPayload';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  FCMtoken: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(
    null
  );

  profileDetails: BehaviorSubject<ProfileDetails | null> =
    new BehaviorSubject<ProfileDetails | null>(null);

  wishListCount: BehaviorSubject<number | null> = new BehaviorSubject<
    number | null
  >(null);

  bagListCount: BehaviorSubject<number | null> = new BehaviorSubject<
    number | null
  >(null);

  selectedLang: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  homeReload: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  classMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  routeToHomeData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  addressList: BehaviorSubject<AddressPayload[] | null> =
    new BehaviorSubject<AddressPayload[] | null>(null);

  constructor(private readonly http: HttpClient) {}

  loginUserByEmail(loginDetails: LoginBody): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/login`, loginDetails)
      .pipe(map(res => res.data));
  }

  loginUserByPhone(loginDetails: LoginBody): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/sendOtp`, loginDetails)
      .pipe(map(res => res.data));
  }

  socialLogin(payload: {
    name: string;
    email: string;
    googleId: string;
  }): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/socialLogin`, payload)
      .pipe(map(res => res.data));
  }

  getProfileDetails(): Observable<ProfileDetails> {
    return this.http
      .get<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/getProfile`)
      .pipe(map(res => res.data));
  }

  signUpUser(payload: signUpBody): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/signup`, payload)
      .pipe(map(res => res.data));
  }

  verifyOtp(payload: LoginBody): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/verifyOtp`, payload)
      .pipe(map(res => res.data));
  }

  updateProfile(payload: ProfileDetails): Observable<ProfileDetails> {
    return this.http
      .put<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/updateProfile`, payload)
      .pipe(map(res => res.data));
  }

  forgotPassword(payload: ForgotPassword): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/forgotPassword`, payload)
      .pipe(map(res => res.data));
  }

  resetPassword(data: ResetPasswordPayload): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/resetPassword`, data)
      .pipe(map(res => res.data));
  }

  verifyEmailOrPhone(payload: verifyEmailOrPhone): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/validateAccount`, payload)
      .pipe(map(res => res.data));
  }

  verifyMailOrPhoneOtp(payload: LoginBody): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/verifyValidate`, payload)
      .pipe(map(res => res.data));
  }

  changePassword(payload: changePasswordPayload): Observable<ProfileDetails> {
    return this.http
      .post<{
        data: ProfileDetails;
      }>(`${environment.base_url}user/changePassword`, payload)
      .pipe(map(res => res.data));
  }

  logout(): Observable<logoutResponse> {
    return this.http.get<logoutResponse>(`${environment.base_url}user/logout`);
  }

  deleteAccount(): Observable<logoutResponse> {
    return this.http.delete<logoutResponse>(
      `${environment.base_url}user/deleteProfile`
    );
  }
}
